export const gdpr = {
  routes: [
    {
      path: "/gdpr/inventory",
      component: () => import("../gdpr-inventory"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/inventory",
      component: () => import("../kvkk-inventory"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/organization/:id/import-panel",
      component: () => import("../import/management-inventory-import-view"),
    },
  ],
};
